import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getAuthenticatedApiClient } from "../../api/apiClient";

/**
 * Graph-backed user lookup behind the shared UserPicker (grant dialog, MFT trading contact person
 * fields). Not scoped to a book: the same query returns the same tenant users whichever page asked.
 */
export const userSearchKeys = {
  all: ["traderAccessUserSearch"] as const,
  search: (q: string) => [...userSearchKeys.all, q] as const
};

export const useUserSearch = (query: string) => {
  const trimmed = query.trim();
  return useQuery({
    queryKey: userSearchKeys.search(trimmed),
    enabled: trimmed.length >= 2,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const apiClient = await getAuthenticatedApiClient();
      const response = await apiClient.userSearch.userSearch({ q: trimmed });
      return response.data;
    }
  });
};
